import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { UserFileApiResult } from '../../Models/DropIn/UserFileApiResult';

@Injectable()
export class UserFilesService {
	constructor(private _http: VisibaApiHttp) {}

	/**
	 * Get file identifier for upload
	 */
	getFileIdentifier(name: string, length: number, type: string) {
		const sendData = {
			Name: name,
			Length: length,
			Type: type === '' ? this.resolveMimeType(name) : type,
		};

		return this._http.postTyped<UserFileApiResult>('/Api/Client/v2/userfiles', sendData);
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	uploadFiles(uploadUrl: string, files: any, sendProgress: boolean = false): Observable<any> {
		return this._http.postFormData(uploadUrl, [], files, sendProgress);
	}

	private resolveMimeType(fileName: string) {
		const extension = fileName.split('.')[fileName.split('.').length];
		switch (extension) {
			case 'doc':
				return 'application/msword';
			case 'docx':
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			default:
				return 'application/octet-stream';
		}
	}
}
